<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-积分管理-积分明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="标题或简介">
          <el-input v-model="formInline.search" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.type" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(v, i) in type" :key="i" :label="v" :value="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange" clearable  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button size="small" type="primary" @click="openPopup('add')" icon="el-icon-plus" v-auth="'/user/points_cate/add'">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="cate_id" label="ID" width="60"></el-table-column>
          <el-table-column prop="type" label="类型" width="100">
            <template slot-scope="scope">
              <span v-if="type[scope.row.type]">{{type[scope.row.type]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" width="200"></el-table-column>
          
          <el-table-column prop="intro" label="简介"></el-table-column>
          <el-table-column prop="point_text" label="积分描述" align="center"></el-table-column>
          <el-table-column prop="point" label="积分" align="center"></el-table-column>

          <el-table-column prop="is_popup" label="弹窗" align="center">
            <template slot-scope="scope">
              <span class="" v-if="scope.row.is_popup">是</span>
              <span class="gray9" v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.status">开启</span>
              <span class="gray9" v-else>关闭</span>
            </template>
          </el-table-column>
          
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column prop="name" label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button @click="openPopup('edit', scope.row)" type="text" size="small" v-auth="'/user/points_cate/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/user/points_cate/del'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--弹窗引入-->
    <Add v-if="show_popup['add']" :is_open="show_popup['add']" :pointsType="type" :oneform="Oneform" @closeDialog="closeDialogFunc($event, 'add')"></Add>

  </div>
</template>

<script>
  import PointsCateApi from '@/api/study/points_cate.js';
  import Add from './part/Add.vue';
  
  export default {
    components: {
      Add
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',
          create_time: '',
          type: ''
        },
        type: [],
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },
        show_popup: {
          add: false,
        },
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        PointsCateApi.getList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.type = data.data.type;
        }).catch(error => {

        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getTableList();
      },

      /*删除*/
      delClick: function(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          //请求接口
          PointsCateApi.del({
            id: row.cate_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });

        });
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.Oneform.type = name;
        if (name == 'edit') name = 'add';
        this.show_popup[name] = true;
        if(item&&typeof(item)!='undefined') this.Oneform.model = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/points/part/Points.vue